import { render, staticRenderFns } from "./SendProposalModal.vue?vue&type=template&id=4cb4df04&"
import script from "./SendProposalModal.vue?vue&type=script&lang=js&"
export * from "./SendProposalModal.vue?vue&type=script&lang=js&"
import style0 from "./SendProposalModal.vue?vue&type=style&index=0&id=4cb4df04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports